import { useTranslation } from 'react-i18next'

import styles from './styles.module.scss'
import { useJoin } from './useJoin'

export const Join = () => {
  const { t } = useTranslation()
  const { disabled, handleJoinConversation } = useJoin()

  return (
    <div className={styles.join}>
      <button onClick={handleJoinConversation} disabled={disabled}>
        {t('Chat.Join')}
      </button>
    </div>
  )
}
